import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bed-allotment-charge.reducer';

export const BedAllotmentChargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bedAllotmentChargeEntity = useAppSelector(state => state.bedAllotmentCharge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bedAllotmentChargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.detail.title">BedAllotmentCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.id">Id</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.id}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.fromDate}</dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.toDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.active">Active</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.timestampEntry}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{bedAllotmentChargeEntity.discount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.allotment">Allotment</Translate>
          </dt>
          <dd>{bedAllotmentChargeEntity.allotment ? bedAllotmentChargeEntity.allotment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.appliedCharge">Applied Charge</Translate>
          </dt>
          <dd>{bedAllotmentChargeEntity.appliedCharge ? bedAllotmentChargeEntity.appliedCharge.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bedAllotmentCharge.multiplierEntry">Multiplier Entry</Translate>
          </dt>
          <dd>{bedAllotmentChargeEntity.multiplierEntry ? bedAllotmentChargeEntity.multiplierEntry.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/bed-allotment-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bed-allotment-charge/${bedAllotmentChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BedAllotmentChargeDetail;
